/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Async controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, AsyncOperationStatusResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AsyncService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getStatus(id?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<AsyncOperationStatusResponse>;
    getStatus(id?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<AsyncOperationStatusResponse>>;
    getStatus(id?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<AsyncOperationStatusResponse>>;
    getStatus(id?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/async/get-status`;

        let params = new HttpParams();
        if (id != null) {
            params = HttpParamsBuilder.addToHttpParams(params, id, 'id');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
